function createMarker(feature, infoWindow, map) {
  let marker = new google.maps.Marker({
    position: feature.getGeometry().get(0),
    icon: {
      url: "https://cdn.shopify.com/s/files/1/0602/6939/6149/files/marker1.png?v=1636030800",
      scaledSize: new google.maps.Size(40, 40),
    }
  });

  marker.addListener('click', function(event) {
    const name = feature.getProperty('name');
    const country = feature.getProperty('country');
    const city = feature.getProperty('city');
    const address = feature.getProperty('address');
    const postal = feature.getProperty('postal');
    const web = feature.getProperty('web');
    const position = feature.getGeometry().get();

    let p1, p2, p3;
    if (country.length > 0) { 
      p1 = `
<p><b>Country: </b>${country}</p>
<p><b>City: </b>${city}</p>
`;
    } else {
      p1 =  `
<p><b>City: </b>${city}</p>
`;
    }

    if (postal.length > 0) {
      p2 =  `<p><b>Address: </b>${address}</p><p><b>Postal: </b>${postal}</p>`;
    } else {
      p2 =  `<p><b>Address: </b>${address}</p>`;
    }

    if (web.length > 0) {
      p3 = `<p><b>About Us: </b><a href="${web}">${web}</a></p>`;
    } else {
      p3 = '';
    }

    const content = `<h2>${name}</h2>${p1}${p2}${p3}`;

    infoWindow.setContent(content);
    infoWindow.setPosition(position);
    infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
    infoWindow.open(map);
  });

  return marker;
}

function initMap() {
  const cycling = document.getElementById('cycling');

  // Create the map.
  let map = new google.maps.Map(document.getElementById('map'), {
    zoom: 3,
    center: {lat: 35, lng: 0},
  });

  const apiKey = 'AIzaSyADvk_2Bov-eHY_pwFNLeNSznu9y0PQImM';
  const infoWindow = new google.maps.InfoWindow();

  // Load the stores GeoJSON onto the map.
  map.data.loadGeoJson(window.geojson, {idPropertyName: 'storeid'}, features => {
    let markers = features.map(feature => createMarker(feature, infoWindow, map));
    
    console.log(markers);

    let markerCluster = new markerClusterer.MarkerClusterer({ map, markers });

    function clusterManager(markers) {
      markerCluster.clearMarkers();
      if (!markers.length) {

      } else {
        for (i=0; i < markers.length; i++) {
          markerCluster.addMarker(markers[i]);
        }
      }
    }

    const mapFilterInputs = document.querySelectorAll('.map-filter input');
    mapFilterInputs.forEach((input, i) => {
      input.addEventListener('change', (e) => {

        if (!e.target.checked) {
          mapFilterInputs.forEach(input => {
            input.checked = false;
          });
        } else {
          mapFilterInputs.forEach(input => {
            input.checked = false;
            e.target.checked = true;
          });
        }

        let markers = [];
        features.forEach(feature => {
          console.log(feature.h);
          if (feature.h.tags.includes(e.target.value)) {
            let marker = createMarker(feature, infoWindow, map);
            markers.push(marker);
          }
        });

        clusterManager(markers);
      });
    });
  });

  // Build and add the search bar
  const card = document.createElement('div');
  const titleBar = document.createElement('div');
  const title = document.createElement('div');
  const container = document.createElement('div');
  const input = document.createElement('input');
  const options = {
    types: ['address']
  };

  card.setAttribute('id', 'pac-card');
  title.setAttribute('id', 'title');
  title.textContent = 'Find the nearest store';
  titleBar.appendChild(title);
  container.setAttribute('id', 'pac-container');
  input.setAttribute('id', 'pac-input');
  input.setAttribute('type', 'text');
  input.setAttribute('placeholder', 'Enter an address');
  container.appendChild(input);
  card.appendChild(titleBar);
  card.appendChild(container);
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

  // Make the search bar into a Places Autocomplete search bar and select
  // which detail fields should be returned about the place that
  // the user selects from the suggestions.
  const autocomplete = new google.maps.places.Autocomplete(input, options);

  autocomplete.setFields(
    ['address_components', 'geometry', 'name']);

  // Set the origin point when the user selects an address
  const originMarker = new google.maps.Marker({
    map: map,
    icon: {
      url: "https://cdn.shopify.com/s/files/1/0602/6939/6149/files/marker2.png?v=1636030800",
      scaledSize: new google.maps.Size(40, 40),
    }
  });
  originMarker.setVisible(false);
  let originLocation = map.getCenter();

  autocomplete.addListener('place_changed', async () => {
                           originMarker.setVisible(false);
  originLocation = map.getCenter();
  const place = autocomplete.getPlace();

  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert('No address available for input: \'' + place.name + '\'');
    return;
  }

  // Recenter the map to the selected address
  originLocation = place.geometry.location;
  map.setCenter(originLocation);
  map.setZoom(9);
  console.log(place);

  originMarker.setPosition(originLocation);
  originMarker.setVisible(true);

  // Use the selected address as the origin to calculate distances
  // to each of the store locations
//   const rankedStores = await calculateDistances(map.data, originLocation);
//   showStoresList(map.data, rankedStores);

  return;
});

map.data.setMap(null);
}